module.exports = __webpack_public_path__ + "static/media/ellipsis-h.2e10e796.svg";